import { useEffect } from 'react';

import {
  pharmacistActions,
  pharmacyActions,
  successOrSelector,
} from '@pharmaplan/common';

import { showSuccess } from '../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import strings from '../localization';

import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';

const {
  createWorkshift,
  updateWorkshift,
  createWorkshiftContract,
  updateWorkshiftContract,
  deleteWorkshift,
  rejectLongTermContract,
  ignoreRequest,
  pharmacyDeleteContract,
} = pharmacyActions;

const {
  createAvailability,
  updateAvailability,
  deleteAvailabilities,
  requestBooking,
  requestContract,
  cancelContractRequest,
  cancelRequestedBooking,
} = pharmacistActions;

const actions = [
  createWorkshift,
  updateWorkshift,
  createWorkshiftContract,
  updateWorkshiftContract,
  deleteWorkshift,
  rejectLongTermContract,
  ignoreRequest,
  createAvailability,
  updateAvailability,
  deleteAvailabilities,
  requestBooking,
  requestContract,
  cancelContractRequest,
  pharmacyDeleteContract,
  cancelRequestedBooking,
];

const useSuccessDialogs = () => {
  const dispatch = useAppDispatch();

  const successDialog = useAppSelector((state) =>
    successOrSelector(actions, state));

  useEffect(() => {
    if (successDialog) {
      showSuccess(dispatch, strings.actionCompletedSuccessfully);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successDialog]);
};

export default useSuccessDialogs;
